@if (displayErrorMessage) {
  <div class="container">
    <div class="row">
      <h4 class="text-danger">{{ 'ssoLogin.globalMessage.ssoLoginFailure' | cxTranslate }}</h4>
    </div>
  </div>
}
